export const STORE_ITEM_CLASS_NAME =
  'bg-background-secondary rounded-md shadow-around-sm p-4 sm:p-5'

export const STORE_ITEM_BUTTON_CLASS_NAME =
  'outline-hidden border border-transparent hover:border-brand-primary focus-visible:border-brand-primary main-transition-colors cursor-pointer'
